const idfServiceIds = {
    advancedFraudMonitoring: "advanced-fraud-monitoring",
    bankAccountMonitoring: "bank-account-monitoring",
    bankAndCreditCardActivity: "bank-and-credit-card-monitoring",
    changeOfAddressMonitoring: "change-of-address-monitoring",
    childCreditActivityMonitoring: "child-credit-activity-monitoring",
    courtRecordsMonitoring: "court-records-monitoring",
    creditCardMonitoring: "credit-card-monitoring",
    creditReportAuthorization: "credit-report-authorization",
    creditScoreMonitoring: "credit-score-monitoring",
    creditScoreSimulator: "credit-score-simulator",
    driversLicenseMonitoring: "driver-license-monitoring",
    emailAddressMonitoring: "email-address-monitoring",
    fraudAlertReminder: "fraud-alert-reminder",
    fraudResolutionSpecialist: "fraud-specialist",
    identityRestorationAdvisor: "identity-restoration-advocate",
    identityTheftInsuranceMillion: "identity-theft-insurance1m",
    identityThreatAlerts: "identity-threat-alerts",
    lostWalletAssistance: "lost-wallet",
    medicalAccountMonitoring: "medical-account-monitoring",
    medicalIDFraudProtection: "medical-fraud-form",
    mothersMaidenNameMonitoring: "maiden-name-monitoring",
    passportMonitoring: "passport-monitoring",
    payDayLoanMonitoring: "pay-day-loan-monitoring",
    shortTermLoanMonitoring: "short-term-loan-monitoring",
    phoneNumberMonitoring: "phone-number-monitoring",
    sexOffenderMonitoring: "sex-offender-monitoring",
    smartSSNTracker: "smart-s-s-n-tracker",
    socialMediaMonitoring: "social-media-monitoring",
    ssnMonitoring: "s-s-n-monitoring",
    threeBureauCreditMonitoring: "three-bureau-credit-monitoring",
    threeBureauCreditReports: "three-bureau-credit-report",
    threeBureauCreditScores: "three-bureau-credit-score",
    transUnionCreditScore: "trans-union-credit-score",
    transUnionCreditReport: "trans-union-credit-report",
    transUnionCreditMonitoring: "trans-union-credit-monitoring",
    financialAccountMonitoring: "financial-account-monitoring",
    darkWebMonitoring: "dark-web-monitoring",
    mobileAttackControl: "mobile-attack-control",
    mobileAttackView: "mobile-attack-view",
    paydayLoanMonitoring: "payday-loan-monitoring",
    virtualPrivateNetworkVpn: "virtual-private-network",
    bankAndCreditCardActivityAlerts: "bank-and-credit-card-activity-alerts",
    investmentAccountAlerts: "investment-account-alerts",
    smartSsnTracker: "smart-ssn-tracker",
    fraudAlertReminders: "fraud-alert-reminders",
    accountTakeoverAlerts: "account-takeover-alerts",
    creditScoreTracker: "credit-score-tracker",
    businessCreditScore: "business-credit-score",
    businessCreditReport: "business-credit-report",
    businessCreditMonitoring: "business-credit-monitoring",
    medicalIdFraudProtection: "medical-id-fraud-protection",
    onlinePcProtectionTools: "online-privacy-suite",
    twoFactorAuthentication: "two-factor-authentication",
    creditFreezeAssistance: "credit-freeze-assistance",
    passwordManager: "password-manager",
    junkMailOptOut: "junk-mail-opt-out",
    mobileApp: "mobile-app",
    securityAssessment: "security-assessment",
    // eslint-disable-next-line spellcheck/spell-checker
    manageEmployes: "manage-employes",
    whiteGloveFamilyRestoration: "personalized-family-restoration",
    whiteGloveRestoration: "personalized-restoration",
    deceasedFamilyMemberFraudRemediation: "deceased-family-member-fraud-remediation",
    stolenFundsReplacement: "stolen-funds-replacement",
    publicRecordMonitoring: "public-records-monitoring",
    IBANMonitoring: "i-b-a-n-monitoring",
    nationalIdMonitoring: "national-i-d-monitoring",
    addressMonitoring: "address-monitoring",
    whiteGloveBusinessRestoration: "personalized-business-restoration",
    myReputation: "reputation-management",
};

export { idfServiceIds };

const ezsServiceIds = {
    idRestorationPro: "SVC-IDR",
    idRestorationProInd: "SVCLVL-IDR-IND",
    idRestorationProWith25kInsurance: "SVCLVL-IDR-IDR-ITI2P",
    idDRestorationProWith1mInsurance: "SVCLVL-IDR-IND-1MM",
    idRestoration: "SVC-IDR-LITE-PARENT",
    idRestorationClassic: "SVCLVL-IDR-LITE",
    onlinePcProtectionTools: "SVC-PC-TOOLS",
    familyIdRestorationPro: "SVCLVL-IDR-FAM",
    familyIdRestorationProWith25kInsurance: "SVCLVL-IDR-FR-ITI2P",
    familyIdRestorationProWith25kInsuranceAndUEFT: "SVCLVL-FIDR25-UEFT",
    familyIdRestorationProWith1MInsurance: "SVCLVL-IDR-FAM-1MM",
    familyIdRestorationClassic: "SVCLVL-IDR-FAM-LITE",
    familyIdRestorationClassicPlusInsurance: "SVCLVL-IDR-FR-LITE",
    familyProtectionService: "SVC-FPS",
    familyProtectionPlus: "SVC-FAMILY-SERVICE",

    darkWebMonitoring: "SVC-INTMON",
    darkWebPhiBot: "SVC-DWM-PHIBOT",
    historicalDarkWebScan: "SVC-DWM-FT",

    mobileAttackControl: "SVC-MOB-DEF",
    publicRecordsMonitoring: "SVC-PUBMON",
    courtRecordsMonitoring: "SVC-CRMON",
    changeOfAddressMonitoring: "SVC-COAMON",
    basicPublicRecordsMonitoring: "SVC-CMCOASSN",
    tuCriminalMonitoring: "SVC-TU-CRIMINAL-MON",
    tuIDPMonitoring: "SVC-TU-IDP",
    sexOffenderMonitoring: "SVC-SOMON",
    paydayLoansMonitoring: "SVC-PDLMON",
    smartSSNTrackerAdult: "SVC-SSNT-ADULT",
    smartSSNTrackerChild: "SVC-SSNT-CHILD",
    financialAccountMonitoring: "SVC-EWS",
    financialTransactionMonitoring: "SVC-YODLEE",
    financialTransactionMonitoringMX: "SVC-FTM-MX",
    creditMonitoring: "SVC-CRDMON",
    tuAdvancedFraudMonitoring: "SVC-AFM", // instant inquiry
    tuChangeOfAddressMonitoring: "SVC-TU-COAMON",
    tuSSNMonitoring: "SVC-TU-SSNMON",

    tuEnhancedCreditAlerts: "SVC-TU-CRDMON-ENH",
    oneBureauCreditMonitoring: "SVCLVL-CRDMON-1B",
    tuOneBureauCreditMonitoring: "SVCLVL-TU-CRDMON-1B",
    tuOneBureauCreditMonitoringBasic: "SVCLVL-TU-CRDMON-1B-BASIC", // without instant inquiry
    quarterlyCreditScore: "SVC-CRDSCORE-1B",
    threeBureauCreditMonitoring: "SVCLVL-CRDMON-3B",
    tuThreeBureauCreditMonitoring: "SVCLVL-TU-CRDMON-3B",
    tuThreeBureauCreditMonitoringBasic: "SVCLVL-TU-CRDMON-3B-BASIC", // without instant inquiry

    oneBureauQuarterlyCreditReport: "SVC-1BQCR",
    experianCreditReport: "SVCLVL-CRDRPT-EXP",
    experianCreditReportwithScore: "SVCLVL-EXP-OTCRDRPT-SCORE", // one time experian credit report with score
    experianAnnualCreditReportWithScore: "SVCLVL-EXP-ACRDRPT-SCORE",
    transCreditReport: "SVCLVL-CRDRPT-TRANS",
    transCreditReportwithScore: "SVCLVL-CRDRPT-TRANS-SCORE",
    creditReportForEachOf3Bureaus: "SVCLVL-CRDRPT-3B",
    creditReportForEachOf3BureausWithScore: "SVCLVL-EXP-OTCRDRPT-3B-SCORE", // one time experin credit report with score 3B
    experianAnnualCreditReportForEachOf3BureausWithScore: "SVCLVL-EXP-ACRDRPT-3B-SCORE",
    creditReportForEachOf3BureausCRDRPT: "SVCLVL-CRDRPT",

    tuCreditReport: "SVCLVL-TU-CRDRPT",
    tuDailyCreditReport: "SVCLVL-TU-DCRDRPT",
    tuMonthlyCreditReport: "SVCLVL-TU-MCRDRPT",
    tuQuarterlyCreditReport: "SVCLVL-TU-QCRDPT",
    tuDailyCreditScore: "SVC-TU-DCRDSCORE-1B",
    tuMonthlyCreditScore: "SVC-TU-MCRDSCORE-1B",
    tuQuarterlyCreditScore: "SVC-TU-QCRDSCORE-1B",
    tuAnnualCreditScore: "SVC-TU-ACRDSCORE-1B",
    tuAnnualCreditReport: "SVCLVL-TU-ACRDRPT",
    tuCreditReportForEachOf3Bureaus: "SVCLVL-TU-CRDRPT-3B",
    tuMonthlyCreditReportForEachOf3Bureaus: "SVCLVL-TU-MCRDRPT-3B",
    tuQuarterlyCreditReportForEachOf3Bureaus: "SVCLVL-TU-QCRDRPT-3B",
    tuAnnualCreditReportForEachOf3Bureaus: "SVCLVL-TU-ACRDRPT-3B",
    tuCreditReportWithScore: "SVCLVL-TU-CRDRPT-SCORE",
    tuDailyCreditReportWithScore: "SVCLVL-TU-DCRDRPT-SCORE",
    tuMonthlyCreditReportWithScore: "SVCLVL-TU-MCRDRPT-SCORE",
    tuQuarterlyCreditReportWithScore: "SVCLVL-TU-QCRDRPT-SCORE",
    tuAnnualCreditReportWithScore: "SVCLVL-TU-ACRDRPT-SCORE",
    tuOneTimeCreditReportWithScore: "SVC-TU-CRDRPT-SCORE-1B-ONETIME",
    tuCreditReportForEachOf3BureausWithScore: "SVCLVL-TU-CRDRPT-3B-SCORE",
    tuMonthlyCreditReportForEachOf3BureausWithScore: "SVCLVL-TU-MCRDRPT-3B-SCORE",
    tuQuarterlyCreditReportForEachOf3BureausWithScore: "SVCLVL-TU-QCRDRPT-3B-SCORE",
    tuAnnualCreditReportForEachOf3BureausWithScore: "SVCLVL-TU-ACRDRPT-3B-SCORE",
    tuCanadaCreditScore: "SVCLVL-TU-CA-SCORE",
    tuCanadaOneTimeCreditReportWithScore: "SVCLVL-TU-CA-CRDRPT-SCORE",
    tuCanadaMonthlyCreditReportWithScore: "SVCLVL-TU-CA-MCRDRPT-SCORE",
    tuCanadaQuarterlyCreditReportWithScore: "SVCLVL-TU-CA-QCRDRPT-SCORE",
    tuCanadaAnnualCreditReportWithScore: "SVCLVL-TU-CA-ACRDRPT-SCORE",

    tuCanadaCreditMonitoring: "SVCLVL-TU-CA-CRDMON",

    tuCanadaCreditScoreSimulator: "SVC-TU-CA-CSS",
    tuCreditScoreSimulator: "SVC-TU-CSS",

    tuCanadaCreditScoreTracker: "SVC-TU-CA-CST",
    tuCreditScoreTracker: "SVC-TU-CST",
    expMonthlyCreditScoreTracker: "SVC-EXP-MCST",

    checkFraudProtection: "CheckFraud",
    monthlyCreditScore: "SVC-CRDSCORE-1B-MONTHLY",
    oneBureauMonthlyCreditReport: "SVC-1BMCR",
    socialMediaMonitoring: "SVC-ZEROFOX",
    checkFraudProtectionLimited: "SVC-CFP-LITE",
    checkingAccountProtection: "SVC-CAP",

    businessIdRestorationPro: "SVC-IDR4BIZ",
    businessIdRestorationClassic: "SVC-IDR4BIZ-LITE",
    smbOneTimePurchase: "SVC-SMB-GP",
    businessDarkWebMonitoring: "SVC-BUSINTMON",
    businessHistoricalDarkWebScan: "SVC-BDWM-FT",
    businessCreditServiceBusinessCredit: "SVC-BIZ-CREDIT",
    businessCreditServiceBusinessCreditPro: "SVC-BIZ-CREDIT-DB",
    businessCreditServiceBusinessCreditSelect: "SVC-BIZ-CREDIT-SELECT",
    businessEWS: "SVC-BUSEWS",
    businessMobileDefenseSuite: "SVC-SMB-MAV",
    macForBusiness: "SVC-MOB-MACBIZ",
    businessCheckFraudProtection: "B-CFP",
    businessCheckFraudProtectionPremium: "SVC-CFP-Premium",
    businessCheckingAccountProtection: "SVC-BCAP",
    businessCyberClaimSupport: "SVC-BIZ-CCS",
    businessIncidentResponseForensics: "SVC-BIZ-IRF",
    businessBreachFulfillmentSupport: "SVC-BIZ-BFS",
    businessIncidentResponsePlan: "SVC-BIZ-IRP",
    businessLearningManagementSystem: "SVC-BIZ-LMS",

    businessIdRestorationProLegacy: "SVC-BSS",
    remoteDepositCaptureAssessmentLegacy: "SVC-RDC",
    identiScreen: "SVC-IDSCREEN",
    businessOpsToolkit: "SVC-PSPET",
    ezShieldVaultSafetyDepositold: "SVC-VAULT",

    myReputation: "SVC-REPIQ",
    seniorsFraudRestoration: "SVC-SENIOR-FRAUD",
    seniorsFraudRestoration25K: "SVC-SENIOR-FRAUD-25K",
    seniorsFraudRestoration1M: "SVC-SENIOR-FRAUD-1M",

    breachIQ: "SVC-BRCLP",
    medicalIdFraudProtection: "SVC-MEDICAL-ID-PROTECT",
    fraudAlertReminder: "SVC-FRAUD-ALERT-REMINDER",
    tuCanadaQuarterlyCreditReport: "SVCLVL-TU-CA-QCRDRPT",
    tuCreditLock: "SVC-TU-CREDIT-LOCK",
    tuCreditLockI: "SVC-TU-CREDIT-LOCK-IA",
    tuCreditLock3b: "SVC-TU-3B-CREDIT-LOCK",
    tuCreditLock3bI: "SVC-TU-3B-CREDIT-LOCK-IA",
    financialCoaching: "SVC-FWC",
};

export { ezsServiceIds };

export const replaceableIDFServices = [
    {
        serviceName: "Credit Score Monitoring",
        replaceWith: "Credit Score Tracker",
    },
    {
        serviceName: "TransUnion Credit Score",
        replaceWith: "VantageScore<sup>&reg;</sup> from TransUnion<sup>&reg;</sup>",
    },
];

export const replaceIDFServiceName = (serviceName: string) => {
    if (serviceName) {
        let replaceableIdfService = replaceableIDFServices.find((it) => it.serviceName === serviceName);
        if (replaceableIdfService) {
            return replaceableIdfService.replaceWith;
        }
    }
    return serviceName;
};

export const protectionPlanIgnoredIDFServiceList = [
    "Bank Account Monitoring",
    "Buy an Instant Credit Report",
    "Credit Card Monitoring",
    "Credit Report Authorization",
    "Driver License Monitoring",
    "Email Address Monitoring",
    // eslint-disable-next-line spellcheck/spell-checker
    "Identity Restoration Advisor",
    "Fraud Resolution Specialist",
    "Medical Account Monitoring",
    "Mother's Maiden Name Monitoring",
    "Passport Monitoring",
    "Phone Number Monitoring",
    "Two-Factor Authentication", // added to resolve bug: 18931
    //  "Credit Score Monitoring",
    //  "Free Annual Credit Report"
];

export const protectionPlanIDFServiceList = [
    "Advanced Fraud Monitoring",
    "Bank and Credit Card Activity",
    "Change of Address Monitoring",
    "Court Records Monitoring",
    "Credit Score Simulator",
    "Fraud Alert Reminder",
    "Identity Theft Insurance $1 Million",
    "Identity Threat Alerts",
    "Lost Wallet Assistance",
    "Medical ID Fraud Protection",
    "Mother's Maiden Name Monitoring",
    "Pay Day Loan Monitoring",
    "Sex Offender Monitoring",
    "Smart SSN Tracker",
    "Social Media Identity Monitoring",
    "Dark Web Monitoring",
    "Three Bureau Credit Monitoring",
    "Three Bureau Credit Reports",
    "Three Bureau Credit Scores",
    "Financial Account Monitoring",
    "Secure My Network (VPN)",
    "Investment Account Alerts",
    "Two-Factor Authentication",
    "Mobile App",
    "Personalized Restoration",
    "Deceased Family Member Fraud Remediation",
    "Personalized Business Restoration",
    "Family 3.0 Child",
    "Family 3.0 Spouse",
];

const userInsuranceServiceList = [
    //#region IDF services
    {
        serviceCode: "id-fraud1m",
        assurantAddonCount: 0,
        assurantProductType: 1,
        state: "",
        serviceDescription: "ID Fraud Insurance $1M Expense Only",
        dollarAmount: "$1 million",
        insuranceDocument: "Assurant - Sontiq $1M Summary of Benefits Expense Only 11.11.19.pdf",
    },
    {
        serviceCode: "id-fraud1m",
        assurantAddonCount: 0,
        assurantProductType: 2,
        state: "",
        serviceDescription: "ID Fraud Insurance $1M Expense Only",
        dollarAmount: "$1 million",
        insuranceDocument: "Assurant - Sontiq $1M Summary of Benefits Expense Only 11.11.19.pdf",
    },
    {
        serviceCode: "id-fraud1m",
        assurantAddonCount: 2,
        assurantProductType: 1,
        state: "NY",
        serviceDescription: "ID Fraud Insurance $1M Expense, UEFT (Savings) & 401k (Investment) (NY)",
        dollarAmount: "$1 million",
        insuranceDocument: "IFS-33-NY-1 COI and CDP Exp Reimb_Cash Rec_HSA FINAL Rev 11.19.2020.pdf",
    },
    {
        serviceCode: "id-fraud1m",
        assurantAddonCount: 0,
        assurantProductType: 1,
        state: "NY",
        serviceDescription: "ID Fraud Insurance $1M Expense Only (NY)",
        dollarAmount: "$1 million",
        insuranceDocument: "IFS-33-NY-1 COI and CDP Exp Reimb_ FINAL Rev 11.19.2020.pdf",
    },
    {
        serviceCode: "id-fraud1m",
        assurantAddonCount: 0,
        assurantProductType: 1,
        state: "TX",
        serviceDescription: "ID Fraud Insurance $1M Expense Only (TX)",
        dollarAmount: "$1 million",
        insuranceDocument: "IFS-33-TX-1 COI and CDP Exp Reim_ FINAL Rev 8.15.2023.pdf",
    },
    {
        serviceCode: "id-fraud1m",
        assurantAddonCount: 1,
        assurantProductType: 1,
        state: "",
        serviceDescription: "ID Fraud Insurance $1M UEFT (Savings)",
        dollarAmount: "$1 million",
        insuranceDocument: "Assurant - Sontiq $1M Summary of Benefits w Cash Recovery 10.18.19.pdf",
    },
    {
        serviceCode: "id-fraud1m",
        assurantAddonCount: 1,
        assurantProductType: 2,
        state: "",
        serviceDescription: "ID Fraud Insurance $1M UEFT (Savings)*",
        dollarAmount: "$1 million",
        insuranceDocument: "Assurant - Sontiq $1M Summary of Benefits w Cash Recovery 10.18.19.pdf",
    },
    {
        serviceCode: "id-fraud1m",
        assurantAddonCount: 2,
        assurantProductType: 1,
        state: "",
        serviceDescription: "ID Fraud Insurance $1M UEFT (Savings) & 401k (Investment)",
        dollarAmount: "$1 million",
        insuranceDocument: "Sontiq $1M $1M $500K.pdf",
    },
    {
        serviceCode: "id-fraud1m",
        assurantAddonCount: 2,
        assurantProductType: 1,
        state: "TX",
        serviceDescription: "ID Fraud Insurance $1M Expense, UEFT (Savings) & 401k (Investment) (TX)",
        dollarAmount: "$1 million",
        insuranceDocument: "IFS-33-TX-1 COI and CDP Exp Reim_Cash Rec_HSA FINAL Rev 8.15.2023.pdf",
    },
    {
        serviceCode: "id-fraud50k",
        serviceDescription: "ID Fraud Insurance $50k Expense Only",
        dollarAmount: "$50,000",
        insuranceDocument: "Assurant - Sontiq $50K Summary of Benefits Expense Only 11.11.19.pdf",
    },
    {
        serviceCode: "id-fraud25k",
        serviceDescription: "ID Fraud Insurance $25k Expense Only",
        dollarAmount: "$25,000",
        insuranceDocument: "Assurant - Sontiq $25K Summary of Benefits Expense Only 11.11.19.pdf",
    },
    {
        serviceCode: "identity-theft-insurance1m",
        serviceDescription: "Identity Theft Insurance $1M UEFT",
        dollarAmount: "$1 million",
        insuranceDocument: "AIG_IdentityForce_Summary_of_Benefits_New_Form_$1M_UEFT_1-2-2020.pdf",
    },
    {
        serviceCode: "identity-theft-insurance25k",
        serviceDescription: "Identity Theft Insurance $25K Std (Expense Only)",
        dollarAmount: "$25,000",
        insuranceDocument: "AIG IdentityForce Summary of Benefits New Form 1-2-2020.pdf",
    },
    {
        serviceCode: "eri25k",
        serviceDescription: "Expense Reimbursement $25K",
        dollarAmount: "$25,000",
        insuranceDocument: "Summary $25K Expense UEFT.pdf",
        aigDocument: "EZShield Summary of Benefits New Form 12-28-2020.pdf",
        swissReUSDocument: "Summary $25K Expense UEFT.pdf",
        swissReCADocument: "Summary $25K Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $25K Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "eri1m",
        serviceDescription: "Expense Reimbursement $1M",
        dollarAmount: "$1 million",
        insuranceDocument: "Summary $1M Expense UEFT.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT.pdf",
        swissReCADocument: "Summary $1M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "eri2m",
        serviceDescription: "Expense Reimbursement $2M",
        dollarAmount: "$2 million",
        insuranceDocument: "Summary $2M Expense UEFT.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT.pdf",
        swissReCADocument: "Summary $2M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT CAN FR.pdf",
    },
    //{ serviceCode: 'IdentityTheftInsurance1M', serviceDescription: 'Identity Theft Insurance $1M UEFT', insuranceDocument: 'AIG IdentityForce Summary of Benefits New Form $1M UEFT 1-2-2020.pdf' },
    //{ serviceCode: 'IdentityTheftInsurance25K', serviceDescription: 'Identity Theft Insurance $25K Std (Expense Only)', insuranceDocument: 'AIG IdentityForce Summary of Benefits New Form 1-2-2020.pdf' },
    //#endregion IDF service codes
    //#region Assurant services
    {
        serviceCode: "SVC-401K-FAM-1MUEFT-NC",
        serviceDescription: "$1M UEFT 401K (Family)",
        dollarAmount: "$1 million",
        insuranceDocument: "Sontiq $1M $1M $500K.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT.pdf",
        swissReCADocument: "Summary $1M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-401K-FAM-CYB-1MUEFT-NC",
        serviceDescription: "$1M UEFT 401K Cyber (Family)",
        dollarAmount: "$1 million",
        insuranceDocument: "Sontiq  $1M UEFT 401K Cyber.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT.pdf",
        swissReCADocument: "Summary $1M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-401K-FAM-2MUEFT-NC",
        serviceDescription: "$2M UEFT 401K (Family)",
        dollarAmount: "$2 million",
        insuranceDocument: "Sontiq $2M UEFT HSA.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT.pdf",
        swissReCADocument: "Summary $2M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-401K-FAM-CYB-2MUEFT-NC",
        serviceDescription: "$2M UEFT 401K Cyber (Family)",
        dollarAmount: "$2 million",
        insuranceDocument: "Sontiq  $2M UEFT 401K Cyber.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT.pdf",
        swissReCADocument: "Summary $2M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-25K-NC",
        serviceDescription: "$25K ID Fraud Insurance",
        dollarAmount: "$25,000",
        insuranceDocument: "Assurant - Sontiq $25K Summary of Benefits Expense Only 11.11.19.pdf",
        swissReUSDocument: "Summary $25K Expense UEFT.pdf",
        swissReCADocument: "Summary $25K Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $25K Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-FAM-2M-TRIO-NY",
        serviceDescription: "$2M UEFT 401K Cyber ID Fraud Insurance Contributory (Family)",
        dollarAmount: "$2 million",
        insuranceDocument: "IFS-33-NY-1 COI and CDP Exp Reimb_Cash Rec_HSA $2M FAMILY 1.25.24.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT.pdf",
        swissReCADocument: "Summary $2M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-FAM-1M-TRIO-NY",
        serviceDescription: "$1M UEFT 401K Cyber ID Fraud Insurance Contributory (Family)",
        dollarAmount: "$1 million",
        insuranceDocument: "IFS-33-NY-1 COI and CDP Exp Reimb_Cash Rec_HSA $1M FAMILY 1.25.24.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT.pdf",
        swissReCADocument: "Summary $1M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-FAM-2M-NC",
        serviceDescription: "$2M ID Fraud Insurance (Family)",
        dollarAmount: "$2 million",
        insuranceDocument: "Sontiq $2M Summary of Benefits.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT.pdf",
        swissReCADocument: "Summary $2M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-FAM-2MUEFT-NC",
        serviceDescription: "$2M UEFT ID Fraud Insurance (Family)",
        dollarAmount: "$2 million",
        insuranceDocument: "Sontiq  $2M UEFT.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT.pdf",
        swissReCADocument: "Summary $2M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-FAM-5M-NC",
        serviceDescription: "$5M ID Fraud Insurance (Family)",
        dollarAmount: "$5 million",
        insuranceDocument: "Sontiq $5M Summary of Benefits NC.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT.pdf",
        swissReCADocument: "Summary $2M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-FAM-5MUEFT-NC",
        serviceDescription: "$5M UEFT ID Fraud Insurance (Family)",
        dollarAmount: "$5 million",
        insuranceDocument: "Sontiq $5M UEFT NC.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT.pdf",
        swissReCADocument: "Summary $2M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-5M-NC",
        serviceDescription: "$5M ID Fraud Insurance",
        dollarAmount: "$5 million",
        insuranceDocument: "Sontiq $5M Summary of Benefits.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT.pdf",
        swissReCADocument: "Summary $2M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-5MUEFT-NC",
        serviceDescription: "$5M UEFT ID Fraud Insurance",
        dollarAmount: "$5 million",
        insuranceDocument: "Sontiq $5M UEFT.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT.pdf",
        swissReCADocument: "Summary $2M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-1M-NC",
        serviceDescription: "$1M ID Fraud Insurance",
        dollarAmount: "$1 million",
        insuranceDocument: "Assurant - Sontiq $1M Summary of Benefits Expense Only 11.11.19.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT.pdf",
        swissReCADocument: "Summary $1M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-1MUEFT-NC",
        serviceDescription: "$1M UEFT ID Fraud Insurance",
        dollarAmount: "$1 million",
        insuranceDocument: "Assurant - Sontiq $1M Summary of Benefits w Cash Recovery 10.18.19.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT.pdf",
        swissReCADocument: "Summary $1M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-25KUEFT-NC",
        serviceDescription: "$25K UEFT ID Fraud Insurance",
        dollarAmount: "$25,000",
        insuranceDocument: "Assurant - Sontiq $25K  Summary of Benefits w Cash Recovery 10.18.19.pdf",
        swissReUSDocument: "Summary $25K Expense UEFT.pdf",
        swissReCADocument: "Summary $25K Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $25K Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-50K-NC",
        serviceDescription: "$50K ID Fraud Insurance",
        dollarAmount: "$50,000",
        insuranceDocument: "Assurant - Sontiq  $50K Summary of Benefits Expense Only 11.11.19.pdf",
        swissReUSDocument: "Summary $25K Expense UEFT.pdf",
        swissReCADocument: "Summary $25K Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $25K Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-FAM-2MNC-TRIO-NY",
        serviceDescription: "$2M UEFT 401K Cyber ID Fraud Insurance Non-Contributory (Family)",
        dollarAmount: "$2 million",
        insuranceDocument: "Sontiq $2M UEFT 401K NC.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT.pdf",
        swissReCADocument: "Summary $2M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-IDFraud-FAM-1MNC-TRIO-NY",
        serviceDescription: "$1M UEFT 401K Cyber ID Fraud Insurance Non-Contributory (Family)",
        dollarAmount: "$1 million",
        insuranceDocument: "Sontiq $1M $1M $500K NC.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT.pdf",
        swissReCADocument: "Summary $1M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT CAN FR.pdf",
    },
    //#endregion Assurant services
    //#region AIG services
    {
        serviceCode: "SVCLVL-IDR-IDR-ITI2P",
        serviceDescription: "Identity Theft Insurance $25K Std (Expense Only)",
        dollarAmount: "$25,000",
        insuranceDocument: "EZShield Summary of Benefits New Form 12-28-2020.pdf",
        swissReUSDocument: "Summary $25K Expense UEFT.pdf",
        swissReCADocument: "Summary $25K Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $25K Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVCLVL-IDR-FR-ITI2P",
        serviceDescription: "Identity Theft Insurance $25K Std (Expense Only)",
        dollarAmount: "$25,000",
        insuranceDocument: "EZShield Summary of Benefits New Form 12-28-2020.pdf",
        swissReUSDocument: "Summary $25K Expense UEFT.pdf",
        swissReCADocument: "Summary $25K Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $25K Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVCLVL-FIDR25-UEFT",
        serviceDescription: "Identity Theft Insurance $25K UEFT",
        dollarAmount: "$25,000",
        insuranceDocument: "EZShield Summary of Benefits New Form $25K UEFT 12-28-2020.pdf",
        swissReUSDocument: "Summary $25K Expense UEFT.pdf",
        swissReCADocument: "Summary $25K Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $25K Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVCLVL-IDR-IND-1MM",
        serviceDescription: "Identity Theft Insurance $1M UEFT",
        dollarAmount: "$1 million",
        insuranceDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT.pdf",
        swissReCADocument: "Summary $1M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVCLVL-IDR-FAM-1MM",
        serviceDescription: "Identity Theft Insurance $1M UEFT",
        dollarAmount: "$1 million",
        insuranceDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT.pdf",
        swissReCADocument: "Summary $1M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-ITI-FAM-25UEFT-NY",
        serviceDescription: "Family Identity Theft Insurance $25K UEFT",
        dollarAmount: "$25,000",
        insuranceDocument: "Sontiq Summary of Benefits New Form $25K UEFT 1-2-2020.pdf",
        swissReUSDocument: "Summary $25K Expense UEFT.pdf",
        swissReCADocument: "Summary $25K Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $25K Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-ITI-FAM-1M-NY",
        serviceDescription: "Family Identity Theft Insurance $1M",
        dollarAmount: "$1 million",
        insuranceDocument: "Sontiq Summary of Benefits New Form $1M UEFT 1-2-2020.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT.pdf",
        swissReCADocument: "Summary $1M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT CAN FR.pdf",
    },
    //#endregion AIG service codes
    //#region Lloyds services
    {
        serviceCode: "SVC-EXPINS-25k",
        serviceDescription: "$25K Expense Reimbursement Insurance",
        dollarAmount: "$25,000",
        insuranceDocument: "Summary $25K Expense UEFT.pdf",
        swissReUSDocument: "Summary $25K Expense UEFT.pdf",
        swissReCADocument: "Summary $25K Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $25K Expense UEFT CAN FR.pdf",
        aigDocument: "EZShield Summary of Benefits New Form $25K UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-EXPINS-1M",
        serviceDescription: "$1M Expense Reimbursement Insurance",
        dollarAmount: "$1 million",
        insuranceDocument: "Summary $1M Expense UEFT.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT.pdf",
        swissReCADocument: "Summary $1M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-EXPINS-2M",
        serviceDescription: "$2M Expense Reimbursement Insurance",
        dollarAmount: "$2 million",
        insuranceDocument: "Summary $2M Expense UEFT.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT.pdf",
        swissReCADocument: "Summary $2M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-RNSM-REIMB",
        serviceDescription: "Ransomware Reimbursement",
        dollarAmount: "$25,000",
        insuranceDocument: "Summary $1M Expense UEFT RW.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT RW.pdf",
        swissReCADocument: "Summary $1M Expense UEFT RW CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT RW CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-SOCENG-REIMB",
        serviceDescription: "Social Engineering Reimbursement",
        dollarAmount: "$25,000",
        insuranceDocument: "Summary $1M Expense UEFT SE.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT SE.pdf",
        swissReCADocument: "Summary $1M Expense UEFT SE.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT SE.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-CB-25K",
        serviceDescription: "Cyberbullying",
        dollarAmount: "$25,000",
        insuranceDocument: "Summary $1M Expense UEFT SE RW 25CB.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT SE RW 25CB.pdf",
        swissReCADocument: "Summary $1M Expense UEFT SE RW 25CB CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT SE RW 25CB CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-CB-50K",
        serviceDescription: "Cyberbullying",
        dollarAmount: "$25,000",
        insuranceDocument: "Summary $1M Expense UEFT SE RW 50CB.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT SE RW 50CB.pdf",
        swissReCADocument: "Summary $1M Expense UEFT SE RW 50CB CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT SE RW 50CB CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    //#endregion
];
export { userInsuranceServiceList };

const expenseReimbursement25K = [
    {
        serviceCode: "SVC-RNSM-REIMB",
        serviceDescription: "Ransomware Reimbursement",
        dollarAmount: "$25,000",
        insuranceDocument: "Summary $1M Expense UEFT RW.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT RW.pdf",
        swissReCADocument: "Summary $1M Expense UEFT RW CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT RW CAN FR.pdf",
        aigDocument: "EZShield Summary of Benefits New Form $25K UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-SOCENG-REIMB",
        serviceDescription: "Social Engineering Reimbursement",
        dollarAmount: "$25,000",
        insuranceDocument: "Summary $1M Expense UEFT SE.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT SE.pdf",
        swissReCADocument: "Summary $1M Expense UEFT SE.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT SE.pdf",
        aigDocument: "EZShield Summary of Benefits New Form $25K UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-SOCENG-REIMB+SVC-RNSM-REIMB", // Combined service code for unique scenario that didn't fit into existing logic
        serviceDescription: "Social Engineering and Ransomware Reimbursement",
        dollarAmount: "$25,000",
        insuranceDocument: "Summary $1M Expense UEFT SE RW.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT SE RW.pdf",
        swissReCADocument: "Summary $1M Expense UEFT SE RW CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT SE RW CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-CB-25K",
        serviceDescription: "Cyberbullying",
        dollarAmount: "$25,000",
        insuranceDocument: "Summary $1M Expense UEFT SE RW 25CB.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT SE RW 25CB.pdf",
        swissReCADocument: "Summary $1M Expense UEFT SE RW 25CB CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT SE RW 25CB CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-CB-50K",
        serviceDescription: "Cyberbullying",
        dollarAmount: "$25,000",
        insuranceDocument: "Summary $1M Expense UEFT SE RW 50CB.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT SE RW 50CB.pdf",
        swissReCADocument: "Summary $1M Expense UEFT SE RW 50CB CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT SE RW 50CB CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
];
export { expenseReimbursement25K };

const expenseReimbursement1M = [
    {
        serviceCode: "SVC-RNSM-REIMB",
        serviceDescription: "Ransomware Reimbursement",
        dollarAmount: "$1 million",
        insuranceDocument: "Summary $1M Expense UEFT RW.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT RW.pdf",
        swissReCADocument: "Summary $1M Expense UEFT RW CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT RW CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-SOCENG-REIMB",
        serviceDescription: "Social Engineering Reimbursement",
        dollarAmount: "$1 million",
        insuranceDocument: "Summary $1M Expense UEFT SE.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT SE.pdf",
        swissReCADocument: "Summary $1M Expense UEFT SE.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT SE.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-SOCENG-REIMB+SVC-RNSM-REIMB", // Combined service code for unique scenario that didn't fit into existing logic
        serviceDescription: "Social Engineering and Ransomware Reimbursement",
        dollarAmount: "$1 million",
        insuranceDocument: "Summary $1M Expense UEFT SE RW.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT SE RW.pdf",
        swissReCADocument: "Summary $1M Expense UEFT SE RW CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT SE RW CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-CB-25K",
        serviceDescription: "Cyberbullying",
        dollarAmount: "$1 million",
        insuranceDocument: "Summary $1M Expense UEFT SE RW 25CB.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT SE RW 25CB.pdf",
        swissReCADocument: "Summary $1M Expense UEFT SE RW 25CB CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT SE RW 25CB CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-CB-50K",
        serviceDescription: "Cyberbullying",
        dollarAmount: "$1 million",
        insuranceDocument: "Summary $1M Expense UEFT SE RW 50CB.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT SE RW 50CB.pdf",
        swissReCADocument: "Summary $1M Expense UEFT SE RW 50CB CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT SE RW 50CB CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
];
export { expenseReimbursement1M };
const expenseReimbursement2M = [
    {
        serviceCode: "SVC-RNSM-REIMB",
        serviceDescription: "Ransomware Reimbursement",
        dollarAmount: "$2 million",
        insuranceDocument: "Summary $2M Expense UEFT RW.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT RW.pdf",
        swissReCADocument: "Summary $2M Expense UEFT RW CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT RW CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-SOCENG-REIMB",
        serviceDescription: "Social Engineering Reimbursement",
        dollarAmount: "$2 million",
        insuranceDocument: "Summary $2M Expense UEFT SE.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT SE.pdf",
        swissReCADocument: "Summary $2M Expense UEFT SE.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT SE.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-SOCENG-REIMB+SVC-RNSM-REIMB", // Combined service code for scenario that didn't fit into existing logic
        serviceDescription: "Social Engineering and Ransomware Reimbursement",
        dollarAmount: "$2 million",
        insuranceDocument: "Summary $2M Expense UEFT SE RW.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT SE RW.pdf",
        swissReCADocument: "Summary $2M Expense UEFT SE RW CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT SE RW CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-CB-25K",
        serviceDescription: "Cyberbullying",
        dollarAmount: "$2 million",
        insuranceDocument: "Summary $2M Expense UEFT SE RW 25CB.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT SE RW 25CB.pdf",
        swissReCADocument: "Summary $2M Expense UEFT SE RW 25CB CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT SE RW 25CB CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
    {
        serviceCode: "SVC-CB-50K",
        serviceDescription: "Cyberbullying",
        dollarAmount: "$2 million",
        insuranceDocument: "Summary $2M Expense UEFT SE RW 50CB.pdf",
        swissReUSDocument: "Summary $2M Expense UEFT SE RW 50CB.pdf",
        swissReCADocument: "Summary $2M Expense UEFT SE RW 50CB CAN.pdf",
        swissReCAFRDocument: "Summary $2M Expense UEFT SE RW 50CB CAN FR.pdf",
        aigDocument: "EZShield AIG Summary of Benefits New Form $1M UEFT 12-28-2020.pdf",
        assurantDocument: "",
    },
];
export { expenseReimbursement2M };

const assurantProductType = { name: "AssurantProductType", contributory: 1, nonContributory: 2 };
export { assurantProductType };

const assurantAddonCount = { name: "AssurantAddonCount", noAddOns: 0, ueft: 1, ueftAnd401k: 2 };
export { assurantAddonCount };

export const isLMSComplete = true; //this flag is set for LMS show/hide LMS implementaion *Do not delete this*

export const enableMXForIDF = true;

export const nyServiceList = [
    "SVC-IDFraud-FAM-1M-TRIO-NY",
    "SVC-IDFraud-FAM-1MNC-TRIO-NY",
    "SVC-IDFraud-FAM-2M-TRIO-NY",
    "SVC-IDFraud-FAM-2MNC-TRIO-NY",
    "SVC-ITI-FAM-25UEFT-NY",
    "SVC-ITI-FAM-1M-NY",
];

export const nyIdfServiceList = [
    {
        serviceCode: "SVC-ITI-FAM-25UEFT-NY",
        serviceDescription: "Family Identity Theft Insurance $25K UEFT",
        dollarAmount: "$25,000",
        insuranceDocument: "IdentityForce Summary of Benefits New Form $25K UEFT 1-2-2020.pdf",
        swissReUSDocument: "Summary $25K Expense UEFT.pdf",
        swissReCADocument: "Summary $25K Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $25K Expense UEFT CAN FR.pdf",
    },
    {
        serviceCode: "SVC-ITI-FAM-1M-NY",
        serviceDescription: "Family Identity Theft Insurance $1M",
        dollarAmount: "$1 million",
        insuranceDocument: "IdentityForce Summary of Benefits New Form $1M UEFT 1-2-2020.pdf",
        swissReUSDocument: "Summary $1M Expense UEFT.pdf",
        swissReCADocument: "Summary $1M Expense UEFT CAN.pdf",
        swissReCAFRDocument: "Summary $1M Expense UEFT CAN FR.pdf",
    },
];

export const nyPackageList = [
    "NEWBPRI",
    "NBFPIAE",
    "NEWBPRF",
    "NBFPFAE",
    "NEWBELI",
    "NBFEIAE",
    "NEWBELF",
    "NBFEFAE",
    "TUIDFUIT",
    "TUIDFUSF",
    "TUIDFUCI",
    "TUIDFUCF",
    "TUIDFUSI",
    "TUIDFUSFFPP",
    "TUIDFUIYA",
    "NEWBENI",
    "NBFENIAE",
    "NEWBENF",
    "NBFENFAE",
    "NEWBCMI",
    "NBFCIAE",
    "NEWBCMF",
    "NBFCFAE",
    "NEWBIDSI",
    "NBFIDSIAE",
    "NEWBIDSF",
    "NBFIDSFAE",
];
export const insuranceFileNy = [
    "IFS-33-NY-1 COI and CDP Exp Reimb_Cash Rec_HSA $1M FAMILY 1.25.24.pdf",
    "IFS-33-NY-1 COI and CDP Exp Reimb_Cash Rec_HSA $2M FAMILY 1.25.24.pdf",
];
